(() => {
  let updating = false;
  const minimumMet = () => {
    const total = document.querySelector('[data-sokameja-cart-total]');
    const changedQuantity = Array.from(document.querySelectorAll('cart-items input[name="updates[]"]'))
      .some((input) => input.value !== input.defaultValue);
    return !!total && Number(total.dataset.sokamejaCartTotal) >= 1000 && !updating && !changedQuantity;
  };
  const syncMinimum = () => {
    const checkout = document.getElementById('checkout');
    if (checkout) checkout.disabled = !minimumMet();
  };

  const validateTerms = () => {
    const checkbox = document.getElementById('SokamejaCartTerms');
    if (!checkbox) return false;
    const error = document.getElementById('SokamejaTermsError');
    if (error) error.hidden = checkbox.checked;
    checkbox.setAttribute('aria-invalid', String(!checkbox.checked));
    checkbox.closest('[data-sokameja-cart-terms]')?.classList.toggle('is-invalid', !checkbox.checked);
    if (!checkbox.checked) {
      checkbox.closest('[data-sokameja-cart-terms]')?.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        block: 'center',
      });
      checkbox.focus({ preventScroll: true });
    }
    return checkbox.checked;
  };

  document.addEventListener('change', (event) => {
    syncMinimum();
    if (event.target.id !== 'SokamejaCartTerms') return;
    validateTerms();
  });

  document.addEventListener('invalid', (event) => {
    if (event.target.id === 'SokamejaCartTerms') {
      event.preventDefault();
      validateTerms();
    }
  }, true);

  document.addEventListener('sokameja:cart-updating', () => { updating = true; syncMinimum(); });
  document.addEventListener('sokameja:cart-settled', () => { updating = false; syncMinimum(); });
  const footer = document.getElementById('main-cart-footer');
  if (footer) new MutationObserver(syncMinimum).observe(footer, { childList: true, subtree: true });
  if (typeof subscribe === 'function') subscribe(PUB_SUB_EVENTS.cartUpdate, ({ cartData }) => {
    if (typeof cartData?.item_count === 'number') {
      document.querySelectorAll('[data-sokameja-cart-count]').forEach((count) => { count.textContent = cartData.item_count; });
    }
    syncMinimum();
  });
  syncMinimum();

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const checkout = event.target.closest('[name="checkout"], a[href*="/checkout"]');
    if (!checkout) return;
    // Every ordinary storefront checkout path must pass through the full cart.
    if (!document.getElementById('SokamejaCartTerms')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.assign(window.routes?.cart_url || '/cart');
    } else if (!minimumMet() || !validateTerms()) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  document.addEventListener('submit', (event) => {
    if (!(event.target instanceof HTMLFormElement)) return;
    if (event.submitter?.name !== 'checkout') return;
    if (!minimumMet() || !validateTerms()) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
})();
